import type { Mission } from '../missions.ts'

export const usgs: Mission = {
  id: "usgs",
  name: "U.S. Geological Survey",
  short: "USGS",
  call: "Earth Science",
  kind: "subagency",
  parent: "doi",
  url: "https://www.usgs.gov/",
  established: 1879,
  palette: {
    primary: "#007150",
    secondary: "#00264c",
    accent: "#ffbe2e",
  },
  colorSource: {
    kind: "brand-guide",
    url: "https://www.usgs.gov/information-policies-and-instructions/usgs-visual-identity-system",
  },
  motif: "hammer",
  mission: {
    text: "The USGS monitors, analyzes, and predicts current and evolving Earth-system interactions and delivers actionable information at scales and timeframes relevant to decision makers.",
    url: "https://www.usgs.gov/about/about-us/who-we-are",
  },
  fact: {
    text: "Clarence King, who had led the Fortieth Parallel survey of the West, became the first Director of the USGS in 1879.",
    url: "https://pubs.usgs.gov/circ/c1050/establish.htm",
  },
  seal: {
    file: "public/seals/usgs.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Geological_Survey.svg",
  },
  logo: {
    file: "public/logos/usgs.svg",
    source: "https://commons.wikimedia.org/wiki/File:USGS_logo_green.svg",
  },
  identifier: {
    about: "https://www.usgs.gov/about/about-us",
    accessibility: "https://www.usgs.gov/accessibility",
    foia: "https://www.usgs.gov/foia",
    noFear: "https://www.doi.gov/pmb/eeo/no-fear-act",
    oig: "https://www.doioig.gov/",
    performance: "https://www.usgs.gov/about/organization/science-support/budget/strategic-planning",
    privacy: "https://www.usgs.gov/privacy",
  },
  media: {
    photos: [
      {
        file: "/media/usgs-hvo-lava-lake.jpg",
        small: "/media/usgs-hvo-lava-lake-sm.jpg",
        alt: "A geologist in a helmet, seen from behind, records observations on the rim of Halema'uma'u crater above a steaming lava lake.",
        title: "HVO geologist observing lava lake in Halema'uma'u, Kilauea, October 5, 2021",
        creator: "N. Deligne, U.S. Geological Survey",
        source: "https://www.usgs.gov/media/images/hvo-geologist-observing-lava-lake-halemaumau-october-5-2021",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/usgs-kilauea-fountains.jpg",
        small: "/media/usgs-kilauea-fountains-sm.jpg",
        alt: "Lava fountains erupt beyond a field of dark, cracked lava crust glowing orange in its seams.",
        title: "Kilauea summit eruption, September 11, 2023",
        creator: "J. Schmith, U.S. Geological Survey",
        source: "https://www.usgs.gov/media/images/kilauea-summit-eruption-september-11-2023-6",
        license: "Public domain (U.S. government work)",
      },
    ],
    video: {
      webm: "/media/usgs-loop.webm",
      mp4: "/media/usgs-loop.mp4",
      poster: "/media/usgs-loop-poster.jpg",
      title: "Evening views of the Halema'uma'u lava lake, Kilauea, September 8, 2022",
      creator: "Hawaiian Volcano Observatory, U.S. Geological Survey",
      source: "https://www.usgs.gov/media/videos/september-8-2022-evening-views-halemaumau-lava-lake-kilauea",
      license: "Public domain (U.S. government work)",
    },
  },
}
